import React from 'react';
import './MetricComparisonCard.less';

/**
 * Loading placeholder shaped like {@link MetricComparisonCard}. Renders no real
 * ticker/name/price/metric data; the blocks are decorative only so the metric
 * list keeps its footprint while the selected page request is pending.
 */
const MetricComparisonCardSkeleton: React.FC = () => (
  <article
    className="comparison-metric-card comparison-metric-card--skeleton"
    aria-hidden="true"
  >
    <div className="comparison-metric-card__chart-panel">
      <div className="comparison-metric-card__price">
        <div className="comparison-metric-card__price-row">
          <span className="comparison-skeleton-block comparison-skeleton-block--code" />
          <span className="comparison-skeleton-block comparison-skeleton-block--name" />
        </div>
        <div className="comparison-metric-card__price-row">
          <span className="comparison-skeleton-block comparison-skeleton-block--price" />
          <span className="comparison-skeleton-block comparison-skeleton-block--change" />
        </div>
      </div>
      <span className="comparison-skeleton-block comparison-skeleton-block--metric-chart" />
    </div>
    <div className="comparison-metric-card__table-panel">
      <span className="comparison-skeleton-block comparison-skeleton-block--metric-table" />
    </div>
  </article>
);

export default MetricComparisonCardSkeleton;
